// Styles
import 'Styles/main.scss';

// Libs
import Vue from 'vue';
import Vuex from 'vuex';
import InputHandler from 'Utils/inputHandler';
import lazySizes from 'lazysizes';

// Components - Keep imports in alpabetical order
// import MyComponent from 'Components/my-component/my-component';
import YoutubePlayer from 'Components/youtube-player/youtube-player';
import TheModal from 'Components/modal/modal';
import MediaGallery from 'Components/media-gallery/media-gallery';
import FilterList from 'Components/filter-list/filter-list';
import ProductFilters from 'Components/product-filters/filters-desktop/product-filters';
import ProductFiltersList from 'Components/product-filters/filters-desktop/product-filters-list';
import StickyBar from 'Components/sticky-bar/sticky-bar';
import ContactForm from 'Components/contact-form/contact-form';
// import ProductFilters from 'Components/product-filters/filters-desktop/product-filters';
import Card from 'Components/card/card';
import Reetag from 'Components/reetag/reetag';
import ProductCardRating from 'Components/ratings-reviews/product-card-rating/product-card-rating';
import ERetailers from 'Components/e-retailers-page/e-retailers';
import Carousel from 'Components/carousel/Carousel';
import Slide from 'Components/carousel/Slide';
import DsfAppPlaceholder from 'Components/dsf-app-placeholder/dsf-app-placeholder';
import FindSalon from 'Components/find-salon/find-salon';
import ChannelAdvisor from 'Components/channel-advisor/channel-advisor.vue';
import MikMakButton from 'Components/mikmak-module/mikmak-module.vue';

import PdpCommerceCta from 'Components/commerce-connector-cta/commerce-connector-cta';
import LanguageSelector from 'Components/language-selector/language-selector';
import LanguageSelectorAuto from 'Components/language-selector-auto/language-selector-auto';
import Sustainability from 'Components/sustainability/sustainability';
import Sustainabilitymodal from 'Components/sustainabilitymodal/sustainabilitymodal';
import Collapse from 'Components/collapse/collapse';
import reviewcontent from 'Components/review-content/review-content.vue';
import quickLink from 'Components/quick-link/quick-link.vue';
import routineSlider from 'Components/routine-slider/routine-slider.vue';
import webzineMagazine from 'Components/webzine-magazine/webzine-magazine.vue';
import highlightedArticles from 'Components/highlighted-articles/highlighted-articles.vue';
import articleFilter from 'Components/article_category/article-filter.vue';
import articleListing from 'Components/article-listing/article-listing.vue'

//Generic Form Components
import GenericForm from 'Components/generic-form/generic-form';
import GenericInput from 'Components/generic-form/generic-input';
import GenericOptions from 'Components/generic-form/generic-options';
import GenericDatepicker from 'Components/generic-form/generic-datepicker';
import GenericSelect from 'Components/generic-form/generic-select';

import ShadeSelector from 'Components/shade-selector/shade-selector.vue';
import PackageSelector from 'Components/package-selector/package-selector.vue';
import mixedContentSlider from 'Components/mixed-content-slider/mixed-content-slider.vue';
import pictureBlock from 'Components/picture/picture.vue';
import videoBlock from 'Components/video/video.vue';
import allMediaBlock from 'Components/all-media-block/all-media-block.vue';
import editorialComponent from 'Components/editorial-component/editorial-component.vue';
import articleSection from 'Components/editorial-component/article-section.vue';

//product share

import Share from 'Components/share/share.vue';
//yext
import Yext from 'Components/yext/yext';

// Directives
import { bus } from 'Directives/bus/bus';
import { tagging } from 'Directives/tagging/tagging';
import { headerNav } from 'Directives/header-nav/header-nav';
import { stickyHeader } from 'Directives/sticky-header/sticky-header';
import { slider } from 'Directives/slider/slider';
import { modal } from 'Directives/modal/modal';
import { titleSup } from 'Directives/titleSup/titleSup';
import { bvTag } from 'Directives/bv-tag/bv-tag';
import { bvLoad } from 'Directives/bv-load/bv-load';
import { triggerChannelAdvisor } from 'Directives/triggerChannelAdvisor/triggerChannelAdvisor';
import { lazyLoadVideo } from 'Directives/lazyLoadVideo/lazyLoadVideo';

import { htmlsafe } from 'Directives/sanitize-html/sanitize-html';
import { hrefsafe } from 'Directives/sanitize-html/sanitize-url';
// PWA support
import 'Utils/registerServiceWorker';

// Generic Form components
import GenericFormWrapper from 'Components/generic-form-wrapper/generic-form-wrapper.vue';
import { tag } from 'Directives/analyticsHandler/tag';

// Configure InputHandler
InputHandler.getInputHandler();

// Components that Vue should ignore
Vue.config.ignoredElements = ['dsf-app'];

Vue.config.productionTip = false;
// Install Vue plugins
window.RefAppRatingsReviews && Vue.use(window.RefAppRatingsReviews);
window.RefAppStoreLocator && Vue.use(window.RefAppStoreLocator);
window.RefAppMctb && Vue.use(window.RefAppMctb);
window.RefAppIframe && Vue.use(window.RefAppIframe);
window.RefAppAmp && Vue.use(window.RefAppAmp);
window.RefAppFaq && Vue.use(window.RefAppFaq);
window.RefAppBanner && Vue.use(window.RefAppBanner);
window.RefAppBeforeAfter && Vue.use(window.RefAppBeforeAfter);
window.RefAppUserRedirect && Vue.use(window.RefAppUserRedirect);
// Vue.use(KeySiteCore);
lazySizes.cfg.lazyClass = 'lazy';

Vue.use(Vuex);
// Register directives globally
Vue.directive(bus.name, bus);
Vue.directive(tagging.name, tagging);
Vue.directive(headerNav.name, headerNav);
Vue.directive(stickyHeader.name, stickyHeader);
Vue.directive(slider.name, slider);
Vue.directive(modal.name, modal);
Vue.directive(titleSup.name, titleSup);
Vue.directive(bvTag.name, bvTag);
Vue.directive(bvLoad.name, bvLoad);
Vue.directive(triggerChannelAdvisor.name, triggerChannelAdvisor);
Vue.directive(tag.name, tag);
Vue.directive(lazyLoadVideo.name, lazyLoadVideo);
Vue.directive(htmlsafe.name, htmlsafe);
Vue.directive(hrefsafe.name, hrefsafe);

// Register components globally - Keep in alpabetical order
// Vue.component('MyComponent', MyComponent);
Vue.component('YoutubePlayer', YoutubePlayer);
Vue.component('MediaGallery', MediaGallery);
Vue.component('TheModal', TheModal);
Vue.component('FilterList', FilterList);
Vue.component('StickyBar', StickyBar);
Vue.component('Card', Card);
Vue.component('ProductFilters', ProductFilters);
Vue.component('Reetag', Reetag);
Vue.component('ContactForm', ContactForm);
// Vue.component('ProductFilters', ProductFilters);
Vue.component('ProductCardRating', ProductCardRating);
Vue.component('ERetailers', ERetailers);
Vue.component('Carousel', Carousel);
Vue.component('Slide', Slide);
Vue.component('DsfAppPlaceholder', DsfAppPlaceholder);
Vue.component('ProductFiltersList', ProductFiltersList);
Vue.component('FindSalon', FindSalon);
Vue.component('PdpCommerceCta', PdpCommerceCta);
Vue.component(GenericFormWrapper.name, GenericFormWrapper);
Vue.component('GenericForm', GenericForm);
Vue.component('GenericInput', GenericInput);
Vue.component('GenericOptions', GenericOptions);
Vue.component('GenericDatepicker', GenericDatepicker);
Vue.component('GenericSelect', GenericSelect);
Vue.component('LanguageSelector', LanguageSelector);
Vue.component('LanguageSelectorAuto', LanguageSelectorAuto);
Vue.component('ChannelAdvisor', ChannelAdvisor);
Vue.component('MikMakButton', MikMakButton);
Vue.component('Yext', Yext);
Vue.component('PdpCommerceCta', PdpCommerceCta);
Vue.component('pictureBlock', pictureBlock);

Vue.component('ShadeSelector', ShadeSelector);
Vue.component('PackageSelector', PackageSelector);
Vue.component('Sustainability', Sustainability);
Vue.component('Sustainabilitymodal', Sustainabilitymodal);
Vue.component('Collapse', Collapse);
Vue.component('PackageSelector', PackageSelector);
Vue.component('reviewcontent', reviewcontent);
Vue.component('routineSlider', routineSlider);
Vue.component('webzineMagazine', webzineMagazine);
Vue.component('quickLink', quickLink);
Vue.component('mixedContentSlider', mixedContentSlider);
Vue.component('videoBlock', videoBlock);
Vue.component('allMediaBlock', allMediaBlock);
Vue.component('editorialComponent', editorialComponent);
Vue.component('articleSection', articleSection);
Vue.component('Share', Share);
Vue.component('highlightedArticles', highlightedArticles);
Vue.component('articleFilter', articleFilter);
Vue.component('articleListing', articleListing)
export default {};
